import { FetchQRStatus } from '@entities/payment'

export const getQrBaseAmount = (
  qrStatusData: FetchQRStatus | undefined,

  isPubg: boolean,

  isTopUpWithPercentFeeService: boolean,
  isNonTopUpServiceDenomation: boolean
) => {
  if (isPubg || isTopUpWithPercentFeeService) {
    return (Number(qrStatusData?.amount?.base) + Number(qrStatusData?.amount?.fee)).toFixed(2)
  }

  if (isNonTopUpServiceDenomation) {
    return (qrStatusData?.amount?.base ?? 0) + 5000
  }

  return qrStatusData?.amount?.base?.toString() || ''
}
